import {localize} from '@/utils/i18n'

export default {
    text: {
        title: localize({
            ru: 'Мы используем файлы cookie и Яндекс Метрику',
            en: 'We use cookies and Yandex Metrica',
            cn: '我们使用 Cookie 和 Yandex Metrica'
        }),
        description: localize({
            ru: 'Оставаясь на&nbsp;сайте, вы&nbsp;соглашаетесь на&nbsp;обработку персональных данных в&nbsp;соответствии с&nbsp;<z-link href="/personal-data-policy/" target="_blank">Политикой</z-link>. Ограничить использование cookie можно в&nbsp;настройках браузера.',
            en: 'Upon continuing to&nbsp;use the site <z-link href="https://irkutskoil.com/" target="_blank">irkutskoil.com</z-link>, you give consent to&nbsp;process your <z-link href="/media/img/Politica.pdf" target="_blank">personal data</z-link> (cookie files, user&nbsp;ID and&nbsp;IP address, information about location, device type, time of&nbsp;visit, referring pages) by&nbsp;means of&nbsp;Google Analytics, Yandex metrics, scripts and other similar counters of&nbsp;your personal data. Personal data processing is&nbsp;made upon the Russian Federal law &#8470;&nbsp;152 adopted on&nbsp;July 27, 2006.<br><br>If you do not wish your personal data to be processed, please, restrict the usage of cookie files in your browser',
            cn: '继续使用 <z-link href="https://irkutskoil.cn/">irkutskoil.cn</z-link> 网站，即表示您同意我们使用 Google Analytics、Yandex Metrics、脚本和其他类似的计数器来处理您的<z-link href="/media/img/Politica.pdf">个人数据</z-link> (Cookie、用户 ID 和 IP 地址、位置信息、设备类型、访问时间、引用页面）。个人数据处理依据 2006 年 7 月 27 日颁布的俄罗斯联邦法律第 152-FZ 号执行。<br><br>如果您不愿意我们处理您的个人数据，请限制浏览器中 Cookie 的使用。'
        }),
        button: {
            agree: localize({
                ru: 'Принять',
                en: 'Accept',
                cn: '接受'
            }),
            more: localize({
                ru: 'Изменить настройки',
                en: 'Change settings',
                cn: 'Change settings'
            })
        }
    },
    settings: [
        {
            title: localize({
                ru: 'Обязательные',
                en: 'Mandatory',
                cn: 'Mandatory'
            }),
            id: 'mandatory',
            locked: true,
            checked: true,
            description: localize({
                ru: 'Эти файлы необходимы для правильной работы сайта и&nbsp;функционала.',
                en: 'These files are necessary for the website to&nbsp;function properly.',
                cn: 'These files are necessary for the website to&nbsp;function properly.'
            })
        },
        {
            title: localize({
                ru: 'Эксплуатационные',
                en: 'Operational',
                cn: 'Operational'
            }),
            id: 'operational',
            locked: false,
            checked: false,
            description: localize({
                ru: 'Эти файлы собирают информацию о&nbsp;том, как вы&nbsp;используете сайт, и&nbsp;помогают нам улучшать его в&nbsp;соответствии с&nbsp;вашими потребностями.',
                en: 'These cookies collect information about how you use the site and help&nbsp;us improve it&nbsp;to&nbsp;suit your needs.',
                cn: 'These cookies collect information about how you use the site and help&nbsp;us improve it&nbsp;to&nbsp;suit your needs.'
            })
        },
        {
            title: localize({
                ru: 'Функциональные',
                en: 'Functional',
                cn: 'Functional'
            }),
            id: 'functional',
            locked: false,
            checked: false,
            description: localize({
                ru: 'Эти файлы позволяют повысить удобство использования сайта, сохраняя информацию о&nbsp;настройках пользователя.',
                en: 'These files improve the usability of&nbsp;the site by&nbsp;storing information about the user&rsquo;s settings.',
                cn: 'These files improve the usability of&nbsp;the site by&nbsp;storing information about the user&rsquo;s settings.'
            })
        },
        {
            title: localize({
                ru: 'Маркетинговые',
                en: 'Marketing',
                cn: 'Marketing'
            }),
            id: 'marketing',
            locked: false,
            checked: false,
            description: localize({
                ru: 'Эти файлы используются для показа рекламной информации, которая может быть вам интересна, в&nbsp;частности, на&nbsp;основе посещенных вами сайтов.',
                en: 'These cookies are used to&nbsp;display promotional information that may be&nbsp;of&nbsp;interest to&nbsp;you, in&nbsp;particular based on&nbsp;the websites you visit.',
                cn: 'These cookies are used to&nbsp;display promotional information that may be&nbsp;of&nbsp;interest to&nbsp;you, in&nbsp;particular based on&nbsp;the websites you visit.'
            })
        }
    ]
}
